import { AdminPageLayout } from "@/features/admin/components/shared";
import { LabelsManagementTable } from "@/features/admin/components/LabelsManagementTable";
import { createFileRoute } from "@tanstack/react-router";
import { useNav } from "@/utils/nav";

const LabelsPage = () => {
    useNav([
        { label: "Admin", route: { to: "/admin" } },
        { label: "Labels", route: { to: "/admin/labels" } },
    ]);

    return (
        <AdminPageLayout
            title="Labels"
            description="Manage diary labels and their resource links. Labels are used for study/trial grouping. Links appear on diary cards for patients."
        >
            <LabelsManagementTable />
        </AdminPageLayout>
    );
};

export const Route = createFileRoute("/_app/admin/labels")({
    component: LabelsPage,
});
